import {ReservationStatusesEnums} from "./statustypes"

export const ColorPickerColors = ["#4E67C8", "#5ECCF3", "#A7EA52", "#5DCEAF", "#FF8021", "#F14124", "#283A7F", "#0E8FBC"];

export const dateFormat = "DD/MM/YYYY";
export const serverDateFormat = "YYYY-MM-DD";
export const dateFormatShort = "DD/MM/YY"
export const dateTimeFormat = "DD/MM/YYYY HH:mm";
export const dateFormatDotted = "DD.MM.YY";
export const dateFormatSpaces = "DD MMM YY";
export const dateTimeFormatSpaced = "DD MMM YYYY HH:mm"
export const dateFormatWithDayInitials = "dd DD/MM";
export const timeFormat = "HH:mm";
export const timeFormatWithSeconds = "HH:mm:ss";
export const maxNumericInputValue = 9999999;
export const maxCustomerNameLength = 25;

export const contentDescriptionLength = 4000;

export const maxPromoCodeLength = 20;
export const maxFieldValueLength = 25

export const OverrideCustomerRestrictionsCustomerId = 1;

export const Designations = {
    Single: 1,
    Double: 2,
    FixBasePrice: 3,
    ExtraPerson: 4,
    FirstExtraAdult: 5,
    SecondExtraAdult: 6,
    ThirdExtraAdult: 7,
    FourthExtraAdult: 8,
    FirstExtraChild: 9,
    SecondExtraChild: 10,
    ThirdExtraChild: 11,
    FourthExtraChild: 12,
    FirstExtraInfant: 13,
    SecondExtraInfant: 14,
    ThirdExtraInfant: 15,
    FourthExtraInfant: 16,
    Room: 17,
    Overall: 18
}

export const DiscountPropertiesEnum = {
    DiscountAmountAfterTax: "DiscountAmountAfterTax",
    DiscountAmountBeforeTax: "DiscountAmountBeforeTax",
    DiscountPercent: "DiscountPercent"
}

export const RestrictionTypes = {
    OpenRestrictionType: 5,
    ClosedRestrictionType: 1,
    ClosedForArrivalRestrictionType: 2,
    ClosedForDepartureRestrictionType: 3,
    ClosedForArrivalAndDepartureRestrictionType: 4,
    ClosedAndClosedForDepartureRestrictionType: 6
}

export const RestrictionTypesValues = {
    1: { value: "C", color: "red", key: "ClosedRestrictionType" },
    2: { value: "A", color: "yellow", key: "ClosedForArrivalRestrictionType" },
    3: { value: "D", color: "blue", key: "ClosedForDepartureRestrictionType" },
    4: { value: "AD", color: "teal", key: "ClosedForArrivalAndDepartureRestrictionType" },
    5: { value: "O", color: "green", key: "OpenRestrictionType" },
    6: { value: "DC", color: "orange", key: "ClosedAndClosedForDepartureRestrictionType" }
}

export const InventoryReflectionTypes = [
    { Name: "FullInventoryReflection", Id: 1 },
    { Name: "NoInventoryReflection", Id: 2 },
    { Name: "ReflectInventoryFromMinimumRooms", Id: 3 }
];

export const MaintenanceStatusTypes = [
    { Name: "OutOfService", Id: 1 },
    { Name: "OutOfOrder", Id: 2 }
];

export const MaintenanceStatusTypeEnum = {
    OutOfService: 1,
    OutOfOrder: 2
}

export const addonOptionsFields = ["MaxPax", "MaxNights", "PartyReservationQuantity", "ConsumptionType", "EveryXnights", "OnSpecificNightsOfTheStay", "OnSpecificWeekdays", "IsConsumptionAfterReservationDay", "IsDistributeToChannelManager"];

export const weekDays = ["SelectDay_Sun", "SelectDay_Mon", "SelectDay_Tue", "SelectDay_Wed", "SelectDay_Thu", "SelectDay_Fri", "SelectDay_Sat"];

export const InventoryReflectionTypesEnum = {
    FullReflectedInventory: 1,
    NoInventoryReflection: 2,
    ReflectInventoryFromSpecifiedValue: 3
}

export const Languages = {
    Arabic: { ID: 1, code: "ar", locale: "ar", Name: 'Arabic' },
    Chinese: { ID: 2, code: "ch", locale: "zh", Name: 'Chinese' },
    English: { ID: 3, code: "en", locale: "en-US", Name: 'English' },
    French: { ID: 4, code: "fr", locale: "fr", Name: 'French' },
    Greek: { ID: 5, code: "gk", locale: "el", Name: 'Greek' },
    German: { ID: 6, code: "gr", locale: "de", Name: 'German' },
    Hebrew: { ID: 7, code: "he", locale: "he-IL", Name: 'Hebrew' },
    Italian: { ID: 8, code: "it", locale: "it", Name: 'Italian' },
    Japanese: { ID: 9, code: "ja", locale: "ja", Name: 'Japanese' },
    Netherlands: { ID: 10, code: "nl", locale: "nl", Name: 'Netherlands' },
    Portuguese: { ID: 11, code: "pr", locale: "pt", Name: 'Portuguese' },
    Russian: { ID: 12, code: "ru", locale: "ru", Name: 'Russian' },
    Spanish: { ID: 13, code: "sp", locale: "es", Name: 'Spanish' },
    Serbian: { ID: 14, code: "sr", locale: "sr", Name: 'Serbian' },
    Swedish: { ID: 15, code: "sw", locale: "sv", Name: 'Swedish' },
};

export const EntityTypes = [
    "None",
    "Reservation",
    "Bon",
    "Guest",
    "Hotel",
    "Amenity",
    "Room",
    "VipCode",
    "Activity",
    "Club",
    "Template",
    "AddOn",
    "RoomType",
    "Report",
    "General",
    "Customer",
    "GuestVoice",
    "Wings",
    "ReservationSources",
    "MarketSegments",
    "Agent",
    "Company",
    "Nationality",
    "User",
    "GuestGroup",
    "HousekeepingStatuses",
    "MaintenanceStatuses",
    "GuestValueType",
    "Package",
    "Group",
    "ApartmentOwner",
    "Workstations",
    "HotelDateparameter",
    "Printers",
    "DefaultPrinters",
    "Diningroom",
    "Roles",
    "Units",
    "HotelChain",
    "NightAudit",
    "GuestSearch",
    "GuestProfile",
    "LoyaltyPrograms",
    "None",
    "None",
    "GuestPreferences",
    "Customers",
    "CustomerGroups",
    "ScheduleMails",
    "GuestValueTypes",
    "Nationality",
    "ReviewSources",
    "GuestTitles",
    "Folio",
    "CurrencyExchange",
    "HotelCurrency",
    "TransactionCodeGroupCategories",
    "TransactionCodeGroups",
    "TransactionRevenueDepartments",
    "TransactionCodes",
    "HotelTaxes",
    "PaymentArrangements",
    "Budgets",
    "TaxTypes",
    "Taxes",
    "HotelCreditCardTypes",
    "Currency",
    "Housekeeping",
    "RoomPlannedMaintenance",
    "HotelWings",
    "Ameneties",
    "RoomLocations",
    "None",
    "None",
    "None",
    "None",
    "Rates",
    "CalendarEvent",
    "Note",
    "Tapechart",
    "FolioIndex",
    "Automation",
    "Documentseries",
    "ApartmentOwners",
    "Automation",
    "ReservationCategory",
    "Restrictions",
    "Dashboard",
    "GuestCommunication",
    "ReceptionAnywhere",
    "ReservationPolicy",
    "HotelAddon",
    "HotelAddonPrice",
    "RatePerPersonPrice",
    "RatePerRoom",
    "RatePerCombinaton",
    "Allocation",
    "PriceGroup",
    "StatisticSource",
    "ClassificationCategories",
    "Promotion",
    "RatePolicyDailyException",
    "RoomSharing",
    "ReservationPolicyException",
    "DepositPolicy",
    "PackageGroup",
    "None",
    "None",
    "None",
    "None",
    "None",
    "None",
    "None",
    "None",
    "None",
    "None",
    "None",
    "None",
    "None",
    "None",
    "None",
    "None",
    "TaxIdentity",
    "None",
    "None",
    "Invoice",
]

export const EntityType = {
    Reservation: 1,
    Guest: 3,
    Hotel: 4,
    Room: 6,
    AddOn: 11,
    RoomType: 12,
    Customer: 15,
    Wings: 17,
    MarketSegment: 19,
    Agent: 20,
    Company: 21,
    Package: 28,
    ReservationGroup: 29,
    ApartmentOwner: 30,
    HotelChain: 38,
    CustomerGroup: 47,
    Folio: 53,
    Rate: 76,
    ReservationPolicy: 90,
    Allocation: 96,
    PriceGroup: 97,
    StatisticSource: 98,
    ClassificationCategories: 99,
    Promotion: 100,
    PackageGroup: 105,
    TaxIdentity: 122,
    Invoice: 125
};

export const CustomerTypes = [
    "None",
    "Company",
    "Agent"
]
export const AddonConsumptionType = {
    EveryNight: 0,
    EveryXNights: 1,
    OnSpecificWeekdays: 2,
    EveryNightExceptFirstNight: 3,
    EveryNightExceptLastNight: 4,
    FirstNightOnly: 5,
    LastNightOnly: 6,
    EveryNightExceptFirstAndLastNights: 7,
    OnSpecificNightsOfTheStay: 8,
    OnGuestDecision: 9
}

export const Actions = {
    EditCalendar: 157,
    ViewHotels: 75,
    RemoveManualRestrictions: 233,
}

export const MenuActions = {
    save: "main-menu-save",
    toggle: "main-menu-toggle",
    note: "main-menu-note",
    copy: "main-menu-copy"
}

export const TemplateType = {
    Confirmation: 1,
    PartyConfirmation: 22,
    GroupConfirmation: 25,
    TermsAndConditions: 27,
    PrivacyPolicy: 28,
}


export const UserDefaultHomePage = {
    HomePage: 0,
    Dashboard: 1,
    Calendar: 2
}

export const ReservationAmountOverrideType = {
    Proportional: 1,
    AmountByNight: 2,
    AmountByTotal: 3,
    Free: 4
}

export const AddonPricingType = {
    Adult: 1,
    Child: 2,
    Infant: 3,
    Room: 4
}

//HS-69601: must match PMS ReservationCategoryType
export const ReservationCategoryType = {
    All: 0,
    System: 1,
    User: 2,
}

export const TaxAuthorityResultCodeTitles = {
    0: "Eligible",
    1: "NotEligible",
    2: "NotFoundOrInvalid",
    3: "LeftTheCountry",
    100: "Error"
}

export const HotelFeatureCodes = {
    ManageAllReservationStatuses: 1,
    SelfieFinance: 2,
    SelfieCreditCardInterface: 3,
    SelfieRevenueManagement: 4,
    SelfieHouseKeeping: 5,
    SelfieApartmentOwners: 6,
    Sms: 7,
    Optima2BasicReports: 8,
    CustomerCommissions: 9,
    ChannelManagerReporting: 10,
    GroupReservations: 11,
    ShowSettingsView: 12,
    CheckTaxExemption: 13,
    Allocations: 14,
    TaxAuthority: 16,
    ClubMember: 17,
    DigitalInvoice: 18
}
export const TaxIdentityFeatureEnum = {
    TaxAuthority: 16,
    DigitalInvoice: 18,
    ['16']:"TaxAuthority",
    ['18']:"DigitalInvoice"
}

export const GuestAccountType = {
    Normal: 1,
    Red: 2,
    Black: 3
}

export const ReservationTypes = {
    Individuals: 0,
    GroupMaster: 1,
    GroupMembers: 2,
}

export const RateCategory = {
    FullRateBaseRate: 1,
    DayUse: 2,
    BasicDealDerivedRate: 3,
    LastMinuteEarlyBookers: 4,
    FreeNights: 5,
    GroupRate: 6,
    CorporateRate: 7,
    ExtraAddOn: 8,
    DerivedPromotion: 9,
    ChannelDiscount: 10,
    Supplement: 11,
    Derived: 12,
    FixPromotion: 13,
}

export const RateCategoriesOrder = [
    RateCategory.FullRateBaseRate, 
    RateCategory.Derived, 
    RateCategory.FixPromotion, 
    RateCategory.Supplement, 
    RateCategory.DayUse, 
    RateCategory.ExtraAddOn
]

//ChannelManager.ExternalCommon.ERateCategory
export const ERateCategory = {
    FullRate: 1,
    DayUse: 2,
    BasicDeal: 3,
    LastMinute: 4,
    FreeNights: 5,
    GroupRates: 6,
    CorporateRate: 7,
    ExtraAddon: 8,
    AgentPromotion: 9,
    ChannelDiscount: 10,
    MultiRateDiscount: 11,
    NotSpecified: 999
}

export const RateTypes =
{
    1: "PerRoom",
    2: "PerPerson",
    3: "FixPerPax",
}

export const RatePricingTypesEnum =
{
    PerRoom: 1,
    PerPerson: 2,
    FixPerPax: 3,
}

export const RateDiscountTypes = {
    1: "OverallDiscount",
    3: "DiscountForEveryXNight",
    4: "HomeSiteDiscount",
}

export const RateDiscountTypesEnum = {
    OverallDiscount: 1,
    DiscountForEveryXNight: 3,
    HomeSiteDiscount: 4,
}

export const AllocationTypesEnum = {
    PerRoomNights: 1,
    PerReservation: 2
}

export const AllocationTypes = {
    1: "AllocationPerRoomNights",
    2: "AllocationPerReservation"
}

export const DiscountApplicationTypes = {
    1: "Product",
    2: "RoomType",
    3: "PackageAddon"
}

export const DiscountApplicationTypesEnum = {
    Product: 1,
    RoomType: 2,
    Addon: 3
}

export const DiscountTypes = {
    1: "Amount",
    2: "Percent"
}

export const DiscountTypesEnum = {
    Amount: 1,
    Percent: 2
}

export const DateRange = {
    CheckIn: "CheckInDateRange",
    CheckOut: "CheckOutDateRange",
}

export const RateCommissionTypes = {
    RateCommission: 0,
    CommissionDeduction: 1
}

export const OperationsEnum = { ADD: 'ADD', REMOVE: 'REMOVE', CHANGE: 'CHANGE' };

/*List of available key-press events can be found here (add to this enum as needed):
https://developer.mozilla.org/en-US/docs/Web/API/UI_Events/Keyboard_event_key_values*/
export const KeyboardKeys = {
    Enter: 'Enter',
    Tab: 'Tab',
    ArrowDown: 'ArrowDown',
    ArrowLeft: 'ArrowLeft',
    ArrowRight: 'ArrowRight',
    ArrowUp: 'ArrowUp',
}

/*List of available key-press events can be found here (add to this enum as needed):
https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent*/
export const keyEventListeners = {
    keyDown: 'keydown',
    keyUp: 'keyup',
}

export const PaymentTypesEnum = {
    Cash: 1,
    CreditCards: 2,
    BankTransfers: 3,
    Voucher: 4,
    CityLedger: 5,
    Check: 6
}

export const NoteStatusEnum = {
    Cancel: 0,
    Open: 1,
    Completed: 2,
};

export const SystemTagsEnum = {
    GuestPending: 1,
    CustomerPending: 2,
    TaxAuthorityPending: 3
}

export const ConnectedRoomTypeEnum = {
    0: 'All',
    1: 'Adjoined',
    2: 'Connected',
    3: 'Connected/Adjoined'
};

export const DerivedCategories = [
    RateCategory.Derived,
    RateCategory.DerivedPromotion
]

export const LevelValues = {
    Hotel: 0,
    RoomType: 1,
    Rate: 2,
    Product: 3
}
export const TransactionCodeHardCodedType = {
    CurrencyExchange: 1,
    CurrencyExchangeCommission: 2,
    AccommodationVoucher: 3,
    AccommodationVoucherPayment: 4,
    Dailyroomcharge: 5,
    CityLedger: 6,
    Rounding: 7,
    Roomphonecharges: 8,
    Defaultdownpayment: 9,
    ExchangeDifference: 10,
    RoomUpgrade: 11,
    DepositCancellationFee: 12,
    AccommodationOwnerCommission: 13,
    ChannelCommission: 14,
    AddonOwnerCommission: 15,
    ManualRoomCharge: 16,
    ExternalAddon: 17
}

export const CollisionType = {
    NO_COLLISION: 0,
    EXACT_MATCH: 1,
    START_BEFORE_END_INSIDE: 2,
    START_INSIDE_END_AFTER: 3,
    RANGE_INSIDE: 4,
    RANGE_ECLIPSES: 5,
}

export const PromotionExcludeEntityTypes = {
    1: "Customer",
    2: "CustomerGroup",
}

export const PromotionExcludeEntityTypeEnum = {
    Customer: 1,
    CustomerGroup: 2
}

export const ApplyLrvFilterTypesEnum = {
    Inherited: 0,
    Yes: 1,
    No: 2
}

export const ApplyLrvFilterTypes = [
    { Name: "Inherited Setting From Base Rate", Id: ApplyLrvFilterTypesEnum.Inherited },
    { Name: "Accept", Id: ApplyLrvFilterTypesEnum.Yes },
    { Name: "Ignore", Id: ApplyLrvFilterTypesEnum.No }
];

export const ForbiddenCharacters = ['\'', '"'];

export const AllWeekDays = [0, 1, 2, 3, 4, 5, 6];

export const TimeReferenceType = {
    BeforeArrivalDate: 0,
    AfterReservationDate: 1
}

export const reasonTypes = {
    Cancellation: 'Cancellation',
    Deletion: 'Deletion',
}

export const reasonTypesIds = {
    Cancellation: 100,
    Deletion: 101,
}

export const reasonTypesStatuses = {
    Cancellation: ReservationStatusesEnums.Cancelled,
    Deletion: ReservationStatusesEnums.Deleted,
}

export const statusesReasonTypes = {
    [ReservationStatusesEnums.Cancelled]: 'Cancellation',
    [ReservationStatusesEnums.Deleted]: 'Deletion',
}

// GTD (Guarantee) types for Reservation Policy
export const RequiredGtdTypes = [
    { Name: "NoGuaranteeRequired", Id: 0 },
    { Name: "CreditCardRequired", Id: 1 },
    { Name: "RoomVoucherRequired", Id: 2 }
];

export const RequiredGtdTypeEnum = {
    NoGuaranteeRequired: 0,
    CreditCardRequired: 1,
    RoomVoucherRequired: 2
};

// GTD Override Statuses for Reservation-level override
export const GtdOverrideStatuses = [
    { Name: "GuaranteedByPolicy", Id: 1 },
    { Name: "OverrideGuaranteed", Id: 2 },
    { Name: "OverrideNotGuaranteed", Id: 3 },
    { Name: "PendingCreditCard", Id: 4 }
];

export const GtdOverrideStatusEnum = {
    GuaranteedByPolicy: 1,
    OverrideGuaranteed: 2,
    OverrideNotGuaranteed: 3,
    PendingCreditCard: 4
};

export const ReservationStatuses =
{
    1: 'Reserved',
    2: 'Checked In',
    3: 'Checked Out',
    4: 'No Show',
    5: 'Cancelled',
    6: 'Arrived',
    7: 'Deleted',
    8: 'Released',
    9: 'Tentative',
    10: 'Option',
    11: 'Waiting List'
}
export const InvoiceStatuses = {
    1: 'Open',
    2: 'Pending',
    3: 'Closed',
    4: 'TechnicalErrors'
};
export const InvoiceStatusesEnum = {
    Open: 1,
    Pending: 2,
    Closed: 3,
    TechnicalErrors: 4
};